import { render, staticRenderFns } from "./LancamentoServicos.vue?vue&type=template&id=6d53617f&scoped=true&"
import script from "./LancamentoServicos.vue?vue&type=script&lang=js&"
export * from "./LancamentoServicos.vue?vue&type=script&lang=js&"
import style0 from "./LancamentoServicos.vue?vue&type=style&index=0&id=6d53617f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d53617f",
  null
  
)

export default component.exports